import axios from "./httpClient";
import { ApiType } from "./Types";
import { getUrl } from "./getURL";
import { ErrorMessages } from "../constants";
import { throwApiError } from "./apiError";

/**
 * CRETE API call using Axios
 * @returns - Create All Shortage Investigation create and update API and return same object
 */

export const ShortageInvestigationCreateUpdateAPI = async (params: any, osdNumber: string, action: string = "save", day?: string) => {
  try {
    const response = await axios.post(`${
      getUrl(ApiType.SHORTAGE_INVESTIGATION)
      .replace(":osdNumber", osdNumber)
      .replace(":day", day!)
      .replace(":action", action)
    }`, params);
    return response.data;
  } catch (error: any) {
    throwApiError(error, ErrorMessages.createUpdateShortageInvestigation);
  }
};
